module.exports = __webpack_public_path__ + "img/web-P4-1.d857112c.png";